<template>
  <div class="mt-8">
    <vs-row class="flex justify-between items-center my-4">
      <h5 class="mb-4 xl:mb-0"><i class="dot"></i> {{ title }}</h5>
      <div class="flex gap-4" v-if="!readonly">
        <AlertUserSelector ref="refUserSelector" class="w-full"
                           v-model="selectedUser" :fullData="true"
                           :readonly="readonly" style="display: none" @select="onSelectUsers" :custom-load-list="loadControlUser"/>
        <vs-button color="secondary" type="border" @click="refreshEnterExitTime">입출문 이력</vs-button>
        <vs-button color="secondary" @click="addItems">인원추가</vs-button>
        <vs-button color="secondary" type="border" @click="deleteItems" :disabled="selected.length === 0">선택삭제</vs-button>
      </div>
    </vs-row>

    <div class="overflow-x-auto">
      <table v-if="localValue">
        <colgroup>
          <col width="40" />
          <col width="160" />
          <col width="120" />
          <col width="120" />
          <col width="160" />
          <col width="140" />
          <col width="120" />
          <col width="80" />
          <col width="80" />
          <col width="120" />
          <col width="120" />
        </colgroup>
        <thead>
          <tr>
            <th rowspan="2" @click="onSelectAll">
              <vs-checkbox class="p-0" :checked="localValue.length !== 0 && selected.length === localValue.length" />
            </th>
            <th rowspan="2">운전장비</th>
            <th rowspan="2">성명</th>
            <th rowspan="2">건설기계 조종사 면허</th>
            <th rowspan="2">생년월일(6자리)</th>
            <th rowspan="2">연락처</th>
            <th rowspan="2">보험증권</th>
            <th colspan="2">정기검사(안전검사)</th>
            <th rowspan="2">입문시간</th>
            <th rowspan="2">출문시간</th>
          </tr>
          <tr>
            <th>실시년도</th>
            <th>검사번호</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tr, indextr) in localValue" :key="indextr">
            <th @click="onSelect(tr)"><vs-checkbox :checked="localValue.length !== 0 && selected.length === localValue.length" /></th>
            <td>
              <div v-if="isPrint" class="print-input">{{ tr.운전장비 }}</div>
              <ml-input v-else :readonly="readonly" v-model="tr.운전장비" class="w-full flex-1" placeholder="입력" @click.stop />
            </td>
            <td>
              <div v-if="isPrint" class="print-input">{{ tr.userName }}</div>
              <member-selector v-else v-model="tr.userId" :member-name="tr.userName" popup-type="user" :disabledUserIds="disabledUserIds" @select="(member) => onSelectUser(indextr, member)" />
              <div v-if="tr.error" class="mt-1 flex gap-2" style="color: #ea5455; font-weight: 500">
                <svg style="min-width: 18px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z"
                    fill="#EA5455"
                  />
                </svg>
                <span>{{ tr.error }}</span>
              </div>
            </td>
            <td>
              <div class="print-input">{{ tr.건설기계조종사면허번호 }}</div>
            </td>
            <td>
              <div class="print-input">{{ tr.생년월일 }}</div>
              <p v-if="tr.err65" class="mt-1" style="font-weight: 400; font-size: 12px; line-height: 17px; text-align: left; color: #ea5455">만 65세 이상 작업자입니다.</p>
            </td>
            <td>
              <div class="print-input">{{ tr.연락처 }}</div>
            </td>
            <td>
              <div class="flex justify-center"><radio-group v-model="tr.보험증권" flex :items="['Y', 'N']" /></div>
            </td>
            <td>
              <div v-if="isPrint" class="print-input">{{ tr.실시년도 }}</div>
              <ml-input v-else v-model="tr.실시년도" placeholder="입력" />
            </td>
            <td>
              <div v-if="isPrint" class="print-input">{{ tr.검사번호 }}</div>
              <ml-input v-else v-model="tr.검사번호" placeholder="입력" />
            </td>
            <td>
              <div v-if="isPrint || !isSafetyManager" class="print-input">{{ tr.입문시간 }}</div>
              <time-selector v-else v-model="tr.입문시간" :readonly="readonly" />
            </td>
            <td>
              <div v-if="isPrint || !isSafetyManager" class="print-input">{{ tr.출문시간 }}</div>
              <time-selector v-else v-model="tr.출문시간" :readonly="readonly" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";

export default {
  name: "WorkerList976",
  components: {
    MemberSelector,
    RadioGroup,
    TimeSelector,
    DateSelector,
    NumberInput,
    FileUploader,
    AlertUserSelector,
    SimpleSpinner,
    PhotoUploadGridModule,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    startDate: String,
    endDate: String,
    title: {
      type: String,
      default: "작업자 내역",
    },
    isPrint: Boolean,
    qrList: {
      type: Array,
      default: () => [],
    },
    refreshQrList: Function,
    // 안전관리자 권한을 갖고있는지
    isSafetyManager: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    disabledUserIds() {
      return this.localValue.map((item) => item.userId);
    },
  },
  watch: {
    qrList(value) {
      if (value && value.length > 0) {
        if (this.updateQrTime) {
          this.updateQrTime(true);
        }
      }
    },
  },
  data() {
    return {
      selectedUser: [],
      selected: [],
    };
  },
  mounted() {},
  methods: {
    // 25.03.26
    // alertUserSelector 장비운전자로 필터링 하여 검색 하기 위함
    async loadControlUser(page, search) {
      const { current, perPage } = page;
      const { type, keyword } = search;

      const params = { searchType: "and", page: current, perPage, projectId: this.$route.params.proj_id };
      switch (type) {
        case "field":
          params.field = keyword;
          break;
        case "company":
          params.company = keyword;
          break;
        case "section":
          params.section = keyword;
          break;
        case "name":
          params.name = keyword;
          break;
      }

      const metaConditions = [];
      metaConditions.push({key: '장비운전자', operator: '=', value: 1})
      params.metaConditions = metaConditions;

      const result = await this.$store.dispatch("member/LOAD_MEMBERS", params);
      const list = result.data
      const lastPage = result.last_page
      return { list, lastPage };

    },
    addItems() {
      this.$refs.refUserSelector.onClickOpenPopup();
    },

    deleteItems() {
      this.localValue = this.localValue.filter((item) => !this.selected.map((item) => item.userId).includes(item.userId));
      this.selectedUser = this.selectedUser.filter((user) => !this.selected.map((item) => item.userId).includes(user.id));
      this.selected = [];
    },

    converterUserDate(user) {
      const metas = this.transformToMeta(user.metas);

      // 내국인:false, 외국인:true
      const is_foreigner = metas.is_foreigner ? "외국인" : "내국인";

      // 65세 이상
      // 간혹 rrn(7자리, YYMMDD{gender}) 을 받아올때 앞자리수가 0인경우에 값을 받아오지 못하는 경우를 대비
      const 생년월일 = metas.rrn ? `${metas.rrn}`.padStart(7, '0').slice(0, -1) : "";
      let err65 = false;
      if (생년월일) {
        const currentYear = new Date().getFullYear();
        const currentCentury = Math.floor(currentYear / 100) * 100; // 현재 세기의 시작 (예: 2000, 1900)
        let birthYear = parseInt(생년월일.substring(0, 2), 10);
        birthYear += birthYear <= currentYear % 100 ? currentCentury : currentCentury - 100;
        const age = currentYear - birthYear -1;
        err65 = age >= 65;
      }

      return {
        // 공통데이터
        id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        userId: user.id,
        userName: user.name,
        성명: {
          id: user.id,
          name: user.name,
        },
        직위: "", // 회원가입시 입력하는 직책과 다를 수 있어서 값을 받아오지 않음
        연락처: user.mobile || user.phone,
        생년월일,
        err65,
        주소: user.home_address_1,
        우편번호: user.home_zip,
        기초안전보건교육수료증: metas.건설업기초안전교육 || {},
        건설기계조종사면허번호: metas.건설기계조종사면허번호,
        is_foreigner,

        // 전용데이터
        운전장비: "",
        건강정보_수축: 0,
        건강정보_이완: 0,
        작업가능여부: "",
        교육만료일자: "",
        입문시간: "",
        출문시간: "",
      };
    },

    transformToMeta(metas) {
      const meta = {};

      metas.forEach(({ meta_key, meta_value }) => {
        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },

    onSelectUser(index, user) {
      this.$set(this.localValue, index, this.converterUserDate(user));
    },
    onSelectUsers(users) {
      this.selectedUser = users;

      // this.localValue 항목 중에서, users[*].id 가 없는 항목을 제거합니다.
      this.localValue = this.localValue.filter((item) => users.map((user) => user.id).includes(item.userId));

      // users[*].id 가 localValue[*].userId 에 없는 항목을 추가합니다.
      users.forEach((user) => {
        if (!this.localValue.map((item) => item.userId).includes(user.id)) {
          this.localValue.push(this.converterUserDate(user));
        }
      });

      // localValue 를 갱신합니다.
      this.localValue = this.localValue.map((item) => {
        return {
          ...item,
        };
      });

      this.updateQrTime(true);
      this.$emit("select", this.localValue);
    },

    onSelectAll() {
      if (this.selected.length === this.localValue.length) {
        this.selected = [];
      } else {
        this.selected = [...this.localValue];
      }
    },

    onSelect(row) {
      if (this.selected.includes(row)) {
        this.selected = this.selected.filter((item) => item.userId !== row.userId);
      } else {
        this.selected.push(row);
      }
    },

    onSelectMember(tr, member) {
      tr.userId = member.id;
      tr.userName = member.name;
      tr.연락처 = member.phone;
    },

    generateRandomId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },

    refreshEnterExitTime() {
      if (this.refreshQrList) {
        this.refreshQrList();
      }
      this.updateQrTime(true);
    },

    /**
     * QR 스캔 데이터를 통해서 입문 시간과 출문 시간을 업데이트한다
     */
    updateQrTime(isForce = false) {
      if (this.qrList.length > 0) {
        this.localValue = this.localValue.map((item) => {
          const userQrs = this.qrList
            .filter((qr) => qr.user_id === item.userId)
            // QR 데이터 중에서, startDate 와 endDate 사이에 있는 데이터만 가져옵니다.
            .filter((qr) => new Date(qr.created_at) >= new Date(`${this.startDate} 00:00:00`) && new Date(qr.created_at) <= new Date(`${this.endDate} 23:59:59`));
          let enterTime = "";
          let exitTime = "";

          if (userQrs.length > 0) {
            for (const qr of userQrs) {
              // qr.created_at 예시 : 2024-11-08 22:03:17
              const createdAt = new Date(qr.created_at);

              // qr.data === '입문' 이고, createdAt 값이 가장 작은 값이 입문시간
              if (qr.data === "입문") {
                if (enterTime === "" || new Date(enterTime) > createdAt) {
                  enterTime = qr.created_at;
                }
              }

              // qr.data === '출문' 이고, createdAt 값이 가장 큰 값이 출문시간
              if (qr.data === "출문") {
                if (exitTime === "" || new Date(exitTime) < createdAt) {
                  exitTime = qr.created_at;
                }
              }
            }
          }

          if ((!item.입문시간 || isForce) && enterTime) {
            item.입문날짜 = enterTime.split(" ")[0];
            item.입문시간 = enterTime.split(" ")[1];
          }
          if ((!item.출문시간 || isForce) && exitTime) {
            item.출문날짜 = exitTime.split(" ")[0];
            item.출문시간 = exitTime.split(" ")[1];
          }

          return item;
        });
      }

      this.$toast.open({ type: "default", message: "QR 데이터를 불러왔습니다.", position: "bottom", duration: 2000 });
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;

    th {
      text-align: center;
      font-weight: 500;
      border-right: solid 1px #cdcdcd;
      background-color: #f9f9f9;
      padding: 16px 0;
    }
    td {
      padding: 6px;
      border-right: solid 1px #cdcdcd;
    }
  }
}
</style>
